module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_vis-2b020682ef348d3a714d03043fabb431.jpg";